import { iWords } from "./types";

export const words: iWords = {
  "0": {
    id: "0",
    arabic: "اللَّهُ",
    english: "Allah",
    transliteration: "Al-lah",
    occurrence: 2550,
    type: "NOUN",
  },
  "1": {
    id: "1",
    arabic: "اَلشَّيْطَان",
    english: "Satan",
    transliteration: "Ash-shaytaan",
    occurrence: 88,
    type: "NOUN",
  },
  "2": {
    id: "2",
    arabic: "هُوَ",
    english: "He",
    transliteration: "Huwa",
    occurrence: 481,
    type: "NOUN",
  },
  "3": {
    id: "3",
    arabic: "هُمْ",
    english: "they",
    transliteration: "Hum",
    occurrence: 444,
    type: "NOUN",
  },
  "4": {
    id: "4",
    arabic: "ﺃَﻧﺖَ",
    english: "You",
    transliteration: "'anta",
    occurrence: 81,
    type: "NOUN",
  },
  "5": {
    id: "5",
    arabic: "ﺃَﻧَﺎ",
    english: "I",
    transliteration: "'anaa",
    occurrence: 68,
    type: "NOUN",
  },
  "6": {
    id: "6",
    arabic: "ﺃَﻧﺘُﻢ",
    english: "you all",
    transliteration: "'antum",
    occurrence: 135,
    type: "NOUN",
  },
  "7": {
    id: "7",
    arabic: "نَحْنُ",
    english: "we",
    transliteration: "nahnu",
    occurrence: 86,
    type: "NOUN",
  },
  "8": {
    id: "8",
    arabic: "ﻣَﻦ",
    english: "who",
    transliteration: "man",
    occurrence: 831,
    type: "NOUN",
  },
  "9": {
    id: "9",
    arabic: "هَلْ",
    english: "Is, Do, Are..?",
    transliteration: "hal",
    occurrence: 93,
    type: "PARTICLE",
  },
  "10": {
    id: "10",
    arabic: "خَيْر",
    english: "best",
    transliteration: "khayr",
    occurrence: 176,
    type: "NOUN",
  },
  "11": {
    id: "11",
    arabic: "اِسْم",
    english: "Name",
    transliteration: "'ism",
    occurrence: 39,
    type: "NOUN",
  },
  "12": {
    id: "12",
    arabic: "ٱلرَّحْمَانِ",
    english: "the Most Gracious",
    transliteration: "'Ar-rahmaan",
    occurrence: 57,
    type: "NOUN",
  },
  "13": {
    id: "13",
    arabic: "ٱلرَّحِيمِ",
    english: "the Most Merciful",
    transliteration: "'Ar-raheem",
    occurrence: 116,
    type: "NOUN",
  },
  "14": {
    id: "14",
    arabic: "ٱلْكَرِيمُ",
    english: "Generous",
    transliteration: "'Al-Kareem",
    occurrence: 27,
    type: "NOUN",
  },
  "15": {
    id: "15",
    arabic: "ٱلْحَمْدُ",
    english: "All praises and thanks",
    transliteration: "'Al-hamd",
    occurrence: 149,
    type: "NOUN",
  },
  "16": {
    id: "16",
    arabic: "لِلَّهِ",
    english: "for Allah / to Allah",
    transliteration: "lil-laahi",
    occurrence: 149,
    type: "NOUN",
  },
  "17": {
    id: "17",
    arabic: "ٱلْعَٰلَمِينَ",
    english: "the worlds",
    transliteration: "'Al-aalameena",
    occurrence: 73,
    type: "NOUN",
  },
  "18": {
    id: "18",
    arabic: "مُسْلِمٌ",
    english: "Muslim",
    transliteration: "Muslim",
    occurrence: 42,
    type: "NOUN",
  },
  "19": {
    id: "19",
    arabic: "مُؤْمِنٌ",
    english: "believer",
    transliteration: "mu'min",
    occurrence: 230,
    type: "NOUN",
  },
  "20": {
    id: "20",
    arabic: "مُشْرِكٌ",
    english: "polytheist",
    transliteration: "mushrik",
    occurrence: 49,
    type: "NOUN",
  },
  "21": {
    id: "21",
    arabic: "كَافِرٌ",
    english: "disbeliever",
    transliteration: "kaafir",
    occurrence: 134,
    type: "NOUN",
  },
  "22": {
    id: "22",
    arabic: "صَٰلِح",
    english: "a righteous person",
    transliteration: "saalih",
    occurrence: 136,
    type: "NOUN",
  },
  "23": {
    id: "23",
    arabic: "يَوْم",
    english: "day",
    transliteration: "yawm",
    occurrence: 405,
    type: "NOUN",
  },
  "24": {
    id: "24",
    arabic: "الدِّين",
    english: "the Judgement",
    transliteration: "'Ad-deen",
    occurrence: 92,
    type: "NOUN",
  },
  "25": {
    id: "25",
    arabic: "إِيَّاكَ",
    english: "You Alone",
    transliteration: "iyyaka",
    occurrence: 24,
    type: "NOUN",
  },
  "26": {
    id: "26",
    arabic: "رَبُّ",
    english: "Lord",
    transliteration: "Rabb",
    occurrence: 971,
    type: "NOUN",
  },
  "27": {
    id: "27",
    arabic: "ﻣَﺎ",
    english: "that which;",
    transliteration: "maa",
    occurrence: 2154,
    type: "NOUN",
  },
  "28": {
    id: "28",
    arabic: "الصِّرَاط",
    english: "the path",
    transliteration: "'As-siraat",
    occurrence: 29,
    type: "NOUN",
  },
  "29": {
    id: "29",
    arabic: "الْمُسْتَقِيم",
    english: "the straight",
    transliteration: "Al-mustaqeem",
    occurrence: 37,
    type: "NOUN",
  },
  "30": {
    id: "30",
    arabic: "ٱلَّذِينَ",
    english: "(of) those",
    transliteration: "'Al-latheena",
    occurrence: 1080,
    type: "NOUN",
  },
  "31": {
    id: "31",
    arabic: "غَيْر",
    english: "not (of)",
    transliteration: "ghayr",
    occurrence: 147,
    type: "NOUN",
  },
  "32": {
    id: "32",
    arabic: "لا",
    english: "not",
    transliteration: "laa",
    occurrence: 1687,
    type: "PARTICLE",
  },
  "33": {
    id: "33",
    arabic: "ٱلضَّٰلِّينَ",
    english: "those who go astray",
    transliteration: "'Ad-daalleena",
    occurrence: 14,
    type: "NOUN",
  },
  "34": {
    id: "34",
    arabic: "هِيَ",
    english: "It; she",
    transliteration: "hiya",
    occurrence: 64,
    type: "NOUN",
  },
  "35": {
    id: "35",
    arabic: "كِتَاب",
    english: "a book",
    transliteration: "kitaab",
    occurrence: 261,
    type: "NOUN",
  },
  "36": {
    id: "36",
    arabic: "أَنزَلْنَا",
    english: "We revealed",
    transliteration: "'anzalna",
    occurrence: 55,
    type: "VERB",
  },
  "37": {
    id: "37",
    arabic: "آيَة",
    english: "sign/verse",
    transliteration: "aayat",
    occurrence: 382,
    type: "NOUN",
  },
  "38": {
    id: "38",
    arabic: "ٱلْأَرْض",
    english: "the earth",
    transliteration: "'Al-ard",
    occurrence: 461,
    type: "NOUN",
  },
  "39": {
    id: "39",
    arabic: "ٱلسَّمَاء",
    english: "the heaven",
    transliteration: "'As-samaa",
    occurrence: 310,
    type: "NOUN",
  },
  "40": {
    id: "40",
    arabic: "ٱوٱوا",
    english: "those of",
    transliteration: "'uloo",
    occurrence: 43,
    type: "NOUN",
  },
  "41": {
    id: "41",
    arabic: "لَوْ",
    english: "if",
    transliteration: "Low",
    occurrence: 201,
    type: "PARTICLE",
  },
  "42": {
    id: "42",
    arabic: "لِ",
    english: "for",
    transliteration: "li",
    occurrence: 1361,
    type: "PARTICLE",
  },
  "43": {
    id: "43",
    arabic: "مِن",
    english: "from",
    transliteration: "min",
    occurrence: 3215,
    type: "PARTICLE",
  },
  "44": {
    id: "44",
    arabic: "عَنْ",
    english: "with",
    transliteration: "'an",
    occurrence: 416,
    type: "PARTICLE",
  },
  "45": {
    id: "45",
    arabic: "لَقَدْ",
    english: "certainly",
    transliteration: "laqad",
    occurrence: 406,
    type: "PARTICLE",
  },
  "46": {
    id: "46",
    arabic: "ٱلْقُرْآن",
    english: "the Qur'an",
    transliteration: "'Al-Qur'aan",
    occurrence: 70,
    type: "NOUN",
  },
  "47": {
    id: "47",
    arabic: "اِنْ",
    english: "if",
    transliteration: "in",
    occurrence: 691,
    type: "PARTICLE",
  },
  "48": {
    id: "48",
    arabic: "شاء",
    english: "wills",
    transliteration: "shaa'a",
    occurrence: 56,
    type: "VERB",
  },
  "49": {
    id: "49",
    arabic: "إِنَّ",
    english: "indeed",
    transliteration: "inna",
    occurrence: 1534,
    type: "PARTICLE",
  },
  "50": {
    id: "50",
    arabic: "إنّم",
    english: "only",
    transliteration: "'innamaa'",
    occurrence: 145,
    type: "PARTICLE",
  },
  "51": {
    id: "51",
    arabic: "عَمَل",
    english: "deed",
    transliteration: "'amal",
    occurrence: 41,
    type: "NOUN",
  },
  "52": {
    id: "52",
    arabic: "بِ",
    english: "in",
    transliteration: "bi",
    occurrence: 510,
    type: "PARTICLE",
  },
  "53": {
    id: "53",
    arabic: "فَيْ",
    english: "in/into",
    transliteration: "fee",
    occurrence: 1684,
    type: "PARTICLE",
  },
  "54": {
    id: "54",
    arabic: "ٱلسَّبِيل",
    english: "the way",
    transliteration: "'As-sabeel",
    occurrence: 176,
    type: "NOUN",
  },
  "55": {
    id: "55",
    arabic: "عَلَى",
    english: "on; upon",
    transliteration: "alaa",
    occurrence: 1423,
    type: "PARTICLE",
  },
  "56": {
    id: "56",
    arabic: "ٱلَّذِي",
    english: "(the one) who",
    transliteration: "allatee",
    occurrence: 304,
    type: "NOUN",
  },
  "57": {
    id: "57",
    arabic: "اَيّٗ",
    english: "which",
    transliteration: "ayyun",
    occurrence: 59,
    type: "NOUN",
  },
  "58": {
    id: "58",
    arabic: "أَحْسَن",
    english: "best",
    transliteration: "'ahsan",
    occurrence: 36,
    type: "NOUN",
  },
  "59": {
    id: "59",
    arabic: "إِلَى",
    english: "to",
    transliteration: "ilaa",
    occurrence: 736,
    type: "PARTICLE",
  },
  "60": {
    id: "60",
    arabic: "مَع",
    english: "with",
    transliteration: "maa",
    occurrence: 163,
    type: "NOUN",
  },
  "61": {
    id: "61",
    arabic: "عِنْدَ",
    english: "with",
    transliteration: "'inda",
    occurrence: 197,
    type: "NOUN",
  },
  "62": {
    id: "62",
    arabic: "الْإِنسَان",
    english: "the mankind",
    transliteration: "Al-insaan",
    occurrence: 65,
    type: "NOUN",
  },
  "63": {
    id: "63",
    arabic: "إِلَّا",
    english: "except",
    transliteration: "'illaa",
    occurrence: 664,
    type: "PARTICLE",
  },
  "64": {
    id: "64",
    arabic: "ٱلْحَقُّ",
    english: "the truth",
    transliteration: "'Al-haqq",
    occurrence: 247,
    type: "NOUN",
  },
  "65": {
    id: "65",
    arabic: "آمَنُوا",
    english: "they believed",
    transliteration: "aamanoo",
    occurrence: 258,
    type: "VERB",
  },
  "66": {
    id: "66",
    arabic: "اَوْ",
    english: "or",
    transliteration: "aw",
    occurrence: 280,
    type: "PARTICLE",
  },
  "67": {
    id: "67",
    arabic: "هَٰذَا",
    english: "this (masculine)",
    transliteration: "haathaa",
    occurrence: 225,
    type: "NOUN",
  },
  "68": {
    id: "68",
    arabic: "هَٰذِهِ ",
    english: "this (feminine)",
    transliteration: "hathihee",
    occurrence: 47,
    type: "NOUN",
  },
  "69": {
    id: "69",
    arabic: "ذَٰلِكَ",
    english: "that (masculine)",
    transliteration: "thaalika",
    occurrence: 478,
    type: "NOUN",
  },
  "70": {
    id: "70",
    arabic: "تِلْك",
    english: "that/these",
    transliteration: "tilka",
    occurrence: 43,
    type: "NOUN",
  },
  "71": {
    id: "71",
    arabic: "ﻫَﺆُﻟَﺎﺀِ",
    english: "these",
    transliteration: "haa'ulaa'i",
    occurrence: 46,
    type: "PARTICLE",
  },
  "72": {
    id: "72",
    arabic: "أُولَئِكَ",
    english: "those",
    transliteration: "'ulaa'ika",
    occurrence: 204,
    type: "NOUN",
  },
  "73": {
    id: "73",
    arabic: "إِذْ",
    english: "when",
    transliteration: "'ith",
    occurrence: 239,
    type: "NOUN",
  },
  "74": {
    id: "74",
    arabic: "إِذَا",
    english: "when",
    transliteration: "'ithaa",
    occurrence: 423,
    type: "NOUN",
  },
  "75": {
    id: "75",
    arabic: "ﺟَﺎﺀَ",
    english: "he came (past tense)",
    transliteration: "jaa'a",
    occurrence: 171,
    type: "VERB",
  },
  "76": {
    id: "76",
    arabic: "النَّاس",
    english: "the people",
    transliteration: "'annaas",
    occurrence: 241,
    type: "NOUN",
  },
  "77": {
    id: "77",
    arabic: "فَعَلَ",
    english: "he did",
    transliteration: "fa'ala",
    occurrence: 100,
    type: "VERB",
  },
  "78": {
    id: "78",
    arabic: "جَعَلَ",
    english: "he made/he set",
    transliteration: "ja'ala",
    occurrence: 344,
    type: "VERB",
  },
  "79": {
    id: "79",
    arabic: "ﻓَﺘَﺢَ",
    english: "he opened/he revealed",
    transliteration: "fataha",
    occurrence: 25,
    type: "VERB",
  },
  "80": {
    id: "80",
    arabic: "قل",
    english: "say",
    transliteration: "qul",
    occurrence: 332,
    type: "VERB",
  },
  "81": {
    id: "81",
    arabic: "أَحَد",
    english: "the One",
    transliteration: "'ahad'",
    occurrence: 74,
    type: "NOUN",
  },
  "82": {
    id: "82",
    arabic: "لَم",
    english: "not",
    transliteration: "lam",
    occurrence: 384,
    type: "PARTICLE",
  },
  "83": {
    id: "83",
    arabic: "لَن",
    english: "never",
    transliteration: "lan",
    occurrence: 106,
    type: "PARTICLE",
  },
  "84": {
    id: "84",
    arabic: "نَصْر",
    english: "help",
    transliteration: "nasr",
    occurrence: 80,
    type: "NOUN",
  },
  "85": {
    id: "85",
    arabic: "ﺧَﻠَﻖَ",
    english: "He created",
    transliteration: "khalaqa",
    occurrence: 237,
    type: "VERB",
  },
  "86": {
    id: "86",
    arabic: "زَكَرَ",
    english: "he remembered",
    transliteration: "zakara",
    occurrence: 151,
    type: "VERB",
  },
  "87": {
    id: "87",
    arabic: "عَبَدَ",
    english: "he worshipped",
    transliteration: "'abada'",
    occurrence: 142,
    type: "VERB",
  },
  "88": {
    id: "88",
    arabic: "شَيْء",
    english: "thing",
    transliteration: "shay'",
    occurrence: 283,
    type: "NOUN",
  },
  "89": {
    id: "89",
    arabic: "ضَرَبَ",
    english: "he hit/he stroke",
    transliteration: "daraba",
    occurrence: 50,
    type: "VERB",
  },
  "90": {
    id: "90",
    arabic: "سَمِعَ",
    english: "he listened",
    transliteration: "sami'a",
    occurrence: 98,
    type: "VERB",
  },
  "91": {
    id: "91",
    arabic: "عَلِم",
    english: "he knew",
    transliteration: "'alima'",
    occurrence: 562,
    type: "VERB",
  },
  "92": {
    id: "92",
    arabic: "عَمِلَ",
    english: "he did",
    transliteration: "'amila",
    occurrence: 318,
    type: "VERB",
  },
  "93": {
    id: "93",
    arabic: "حَدِيث",
    english: "statement; story",
    transliteration: "hadeeth",
    occurrence: 23,
    type: "NOUN",
  },
  "94": {
    id: "94",
    arabic: "إلٰه",
    english: "the God",
    transliteration: "'ilaah",
    occurrence: 145,
    type: "NOUN",
  },
  "95": {
    id: "95",
    arabic: "صَدْر",
    english: "chest",
    transliteration: "sadr",
    occurrence: 44,
    type: "NOUN",
  },
  "96": {
    id: "96",
    arabic: "ملاك",
    english: "angel",
    transliteration: "malak",
    occurrence: 88,
    type: "NOUN",
  },
  "97": {
    id: "97",
    arabic: " جِنَّت",
    english: "Jinn",
    transliteration: "jinnah",
    occurrence: 32,
    type: "NOUN",
  },
  "98": {
    id: "98",
    arabic: "يَا",
    english: "O; oh",
    transliteration: "yaa",
    occurrence: 361,
    type: "PARTICLE",
  },
  "99": {
    id: "99",
    arabic: "قَوْم",
    english: "people",
    transliteration: "qawm",
    occurrence: 383,
    type: "NOUN",
  },
  "100": {
    id: "100",
    arabic: "أَيُّهَا",
    english: "O; oh",
    transliteration: "'ayyuhaa'",
    occurrence: 153,
    type: "PARTICLE",
  },
  "101": {
    id: "101",
    arabic: "اَنْ",
    english: "that",
    transliteration: "'an",
    occurrence: 571,
    type: "PARTICLE",
  },
  "102": {
    id: "102",
    arabic: "ﺃَﻥَّ",
    english: "that",
    transliteration: "'anna",
    occurrence: 359,
    type: "PARTICLE",
  },
  "103": {
    id: "103",
    arabic: "مُحَمَّد",
    english: "Muhammad",
    transliteration: "Muhammad",
    occurrence: 4,
    type: "NOUN",
  },
  "104": {
    id: "104",
    arabic: "رَسُول",
    english: "Messenger",
    transliteration: "Rasool",
    occurrence: 332,
    type: "NOUN",
  },
  "105": {
    id: "105",
    arabic: "ٱلصَّلَاةُ",
    english: "the prayer",
    transliteration: "'As-salat",
    occurrence: 83,
    type: "NOUN",
  },
  "106": {
    id: "106",
    arabic: "شَرِيك",
    english: "partner",
    transliteration: "shareek",
    occurrence: 40,
    type: "NOUN",
  },
  "107": {
    id: "107",
    arabic: "مَاْذَاْ",
    english: "what",
    transliteration: "maathaa",
    occurrence: 27,
    type: "NOUN",
  },
  "108": {
    id: "108",
    arabic: "سُبْحَانَهُ",
    english: "Glory",
    transliteration: "subhaana",
    occurrence: 41,
    type: "NOUN",
  },
  "109": {
    id: "109",
    arabic: "الْعَظِيم",
    english: "The Great",
    transliteration: "Al-adheem",
    occurrence: 107,
    type: "NOUN",
  },
  "110": {
    id: "110",
    arabic: "طَيِّبَات",
    english: "good things",
    transliteration: "tayyibaat",
    occurrence: 46,
    type: "NOUN",
  },
  "111": {
    id: "111",
    arabic: "سَلَامٌ",
    english: "Peace",
    transliteration: "salaam",
    occurrence: 42,
    type: "NOUN",
  },
  "112": {
    id: "112",
    arabic: "نَبِي",
    english: "The Prophet",
    transliteration: "'an-nabi",
    occurrence: 75,
    type: "NOUN",
  },
  "113": {
    id: "113",
    arabic: "رَحْمَة",
    english: "(the) Mercy",
    transliteration: "rahmah",
    occurrence: 114,
    type: "NOUN",
  },
  "114": {
    id: "114",
    arabic: "عِبَادٌ",
    english: "slaves, servants",
    transliteration: "'ibaad",
    occurrence: 125,
    type: "NOUN",
  },
  "115": {
    id: "115",
    arabic: "سَوْفَ",
    english: "soon",
    transliteration: "sawfa",
    occurrence: 15,
    type: "NOUN",
  },
  "116": {
    id: "116",
    arabic: "إِبْرَاهِيم",
    english: "Ibrahim",
    transliteration: "'ibraaheem",
    occurrence: 69,
    type: "NOUN",
  },
  "117": {
    id: "117",
    arabic: "نَفْس",
    english: "soul",
    transliteration: "nafs",
    occurrence: 293,
    type: "NOUN",
  },
  "118": {
    id: "118",
    arabic: "كَثِيْر",
    english: "much",
    transliteration: "katheer",
    occurrence: 140,
    type: "NOUN",
  },
  "119": {
    id: "119",
    arabic: "اَلنُّ نُوْب",
    english: "the sins",
    transliteration: "Ath-thunoob",
    occurrence: 39,
    type: "NOUN",
  },
  "120": {
    id: "120",
    arabic: "غَفُورُ",
    english: "Oft-Forgiving",
    transliteration: "gafoor",
    occurrence: 91,
    type: "NOUN",
  },
  "121": {
    id: "121",
    arabic: "ٱلدُّنْيَا",
    english: "the world",
    transliteration: "Ad-dunya",
    occurrence: 115,
    type: "NOUN",
  },
  "122": {
    id: "122",
    arabic: "الآخِرَة",
    english: "the Hereafter",
    transliteration: "'Al-Akhirat",
    occurrence: 115,
    type: "NOUN",
  },
  "123": {
    id: "123",
    arabic: "عَذَاب",
    english: "punishment",
    transliteration: "'athaab",
    occurrence: 322,
    type: "NOUN",
  },
  "124": {
    id: "124",
    arabic: "اَلنَّار",
    english: "the Fire",
    transliteration: "An-naar",
    occurrence: 145,
    type: "NOUN",
  },
};
